export default __webpack_public_path__ + "static/media/07_DAIF_SUSTAINABILITY_02_loop.f7e67c60.mp4";